import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
const SafeView = (props) => {
    const { children } = props;
    return (_jsx(Box, { pl: {
            base: "15px",
            md: "30px",
        }, pr: {
            base: "15px",
            md: "30px",
        }, children: children }));
};
export default SafeView;
//# sourceMappingURL=safeView.js.map